import { Redirect, Route, Switch } from "react-router-dom";
import Page404 from "../../components/global_components/Page404";
import { Products } from "../../constants/products";
import useEnsureCanUseProduct from "../../hooks/useEnsureCanUseProduct";
import { useLoginToast } from "../../hooks/useLoginToast";
import identitySelectors from "../../selectors/identity";
import permissions from "../../selectors/permissions";
import useSite from "../permits/components/inspections/InspectionPanel/useSite";
import { NotifyNotificationsCreateFromTemplatePage } from "./routes/notify/notifications/pages/create-from-template/NotifyNotificationsCreateFromTemplatePage";
import { NotifyNotificationsCreatePage } from "./routes/notify/notifications/pages/create/NotifyNotificationsCreatePage";
import { NotifyNotificationsDetailPage } from "./routes/notify/notifications/pages/detail/NotifyNotificationsDetailPage";
import { NotifyNotificationsPage } from "./routes/notify/notifications/pages/notifications/NotifyNotificationsPage";
import { NotifySubscribersPage } from "./routes/notify/subscribers/NotifySubscribersPage";
import { SubscriptionGroupsPage } from "./routes/notify/subscription-groups/SubscriptionGroupsPage";

export function NotifyApp() {
  useLoginToast();
  const { loggedOutRedirect, loader, productRedirect } = useEnsureCanUseProduct({
    products: Products.COMMUNICATIONS,
    permissions: () => {
      return (
        permissions.can("manage_communications")() ||
        identitySelectors.isCommunicationsUser() ||
        identitySelectors.isCommunicationsAdmin()
      );
    },
  });
  const site = useSite();
  if (loggedOutRedirect) return loggedOutRedirect;
  if (loader) return loader;
  if (productRedirect) return productRedirect;

  localStorage.setItem(`${site}-last-product`, Products.COMMUNICATIONS);

  return (
    <Switch>
      <Route exact path='/:site/notify/notifications/create' render={() => <NotifyNotificationsCreatePage />} />
      <Route exact path='/:site/notify/notifications/:id' render={() => <NotifyNotificationsDetailPage />} />
      <Route
        exact
        path='/:site/notify/notifications/create/from-template'
        render={() => <NotifyNotificationsCreateFromTemplatePage />}
      />
      <Route exact path='/:site/notify/notifications' render={() => <NotifyNotificationsPage />} />
      <Route exact path='/:site/notify/subscribers' render={() => <NotifySubscribersPage />} />
      <Route exact path='/:site/notify/subscription-groups' render={() => <SubscriptionGroupsPage />} />
      <Redirect from='/:site/notify' to='/:site/notify/notifications' exact />
      <Route render={() => <Page404 />} />
    </Switch>
  );
}
